(function($, duo) {

	"use strict";

/** --------------------------------------------------
 *
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   document ready
 *   window load
 *   drupal behavior
 *   overrule behavior
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {
		// $(document).ready is a jQuery event that
		// gets called as soon as the DOM is ready

		// header:
		new duo.Header();

		// paragraphs:
		new duo.Paragraphs();
		// -> moodboard products:
		new duo.MoodboardProduct();

		// newsletter blocks:
		new duo.NewsletterBlock({
			newsletterBlockSelector: '.newsletter-block__content'
		});

		// faq - accordions:
		new duo.Accordion({
			containerSelector: '.faq-teaser-list',
			itemSelector:'.node--type-faq-detail.node--view-mode-teaser',
			titleSelector:'.faq-teaser__title',
			contentSelector:'.faq-teaser__content',
			openClass: 'js-item-opened',
			openedIndex: 0,
			enableKeyboardEvents: true,
			onlyAllowOneOpenItem: false
		});

		// faq - subnavigation:
		const faq_subnav = new duo.Subnavigation({
			navSelector: '.faq-category-list .view-content',
			toggleText: 'Select a FAQ category'
		});
		// -> set active menu-item:
		faq_subnav.setActivePageLinks();

		// @todo: move this somewhere else
		$(document).on('click', '.form-commerce-cart .views-view-table + .fancy-button', function() {
			$(this).addClass('cart-loading');
		});

		if($('body').hasClass('node--type-beurs-onepager')) {
			setTimeout(function(){
				$('body').addClass('hide-signup-message');
			  }, 5000);
		}

        // Make barcode app always fill screen regardless of toolbar state
        const appBody = document.querySelector('.path-barcode-scanner');
        if (appBody) {
            // First we get the viewport height and we multiply it by 1% to get a value for a vh unit
            let vh = window.innerHeight * 0.01;
            appBody.style.setProperty('--vh', vh + 'px');

            let vhOnResize = duo.Utils.debounce(function() {
                let vh = window.innerHeight * 0.01;
                appBody.style.setProperty('--vh', vh + 'px');
            }, 250);

            window.addEventListener('resize', vhOnResize);
        }


		// on window resize:
		$(window).resize(function() {

			// moodboard products:
			new duo.MoodboardProduct();
		});

	});




/** --------------------------------------------------
    #window load
    -------------------------------------------------- */

	$(window).on('load', function() {
		// $(window).on('load') executes when the page
		// is fully loaded, including all objects and
		// images
	});




/** --------------------------------------------------
    #drupal behavior
    -------------------------------------------------- */

	Drupal.behaviors.default = {
		attach: function (context, settings) {

			// file uploads:
			new duo.FileUpload({
				fileuploadInputSelector: '.form-type-managed-file .form-file'
			});

			// vat form field - input mask:
			let allowInputMask = true;
			// -> check browser:
			const ua_parser = new UAParser();
			const result = ua_parser.getResult();
			if(result.browser.name === 'UCBrowser') {
				allowInputMask = false;
			}
			if(allowInputMask) {
				/* when using jquery inputmask: */
				/* $('.form-item[class*="form-item-field-vat-"] input').inputmask({
					mask: "9{4}.9{3}.9{3}",
					casing: 'upper',
					noValuePatching: 'true',
					disablePredictiveText: true,
					placeholder: '_',
					numericInput: false,
					undoOnEscape: true,
				}); */
				/* using imask.js: */
				if($('.form-item[class*="form-item-field-vat-"] input').length > 0) {
					const vat_mask = new IMask(
						$('.form-item[class*="form-item-field-vat-"] input')[0],
						{
							mask: '0000.000.000',
							lazy: true,
						});
				}
				// for the guest checkout:
				if($('.form-item[class*="form-item-hairco-commerce__payment-information-billing-information-field-vat-number-"] input').length > 0) {
					const vat_mask = new IMask(
						$('.form-item[class*="form-item-hairco-commerce__payment-information-billing-information-field-vat-number-"] input')[0],
						{
							mask: '0000.000.000',
							lazy: true,
						});
				}
			}

		}
	};

	Drupal.behaviors.addressNumberCheck = {
		attach: function(context, settings) {
			$('.field--type-address .address-line1, .checkout-pane-duo-commerce-delivery--delivery .address-line1', context)
				.each(function(i, el) {
					if (!$(el).hasClass('processed')) {
						$(el).before($('<div></div>', { class: 'form--custom-addressline-warning' }));
						$(el).addClass('processed');

						$(el).on('blur', function(e) {
							if (/\d/.test(this.value.trim())) {
								$(this).removeClass(['error', 'prevent-submit']);
								$(this).prev('.form--custom-addressline-warning').text('');
								$(this).closest('form').find('.form--custom-prevent-warning').remove();
							} else {
								$(this).addClass(['error', 'prevent-submit']);
								$(this).prev('.form--custom-addressline-warning').text(Drupal.t('Please enter a full address including street & number.'));
							}
						});
					}
				});

			$('.user-register-form, .user-form, form.commerce-checkout-flow', context).on('submit', function(e) {
				var allowSubmit = true;
				var warnings = [];

				$(this).find('.address-line1').each(function(i, el) {
					if (!/\d/.test(el.value.trim())) {
						warnings.push($(el));
					}
				});

				if (warnings.length) {
					allowSubmit = false;
					// Remove previous warnings if any (for trigger happy users)
					$(this).find('.form--custom-prevent-warning').remove();

					var firstWarningFieldset = warnings[0].closest('fieldset').find('.fieldset-legend').text();
					$(this).find('.form-actions').before($('<div></div>', {
						class: 'form--custom-prevent-warning messages messages--error',
						html: Drupal.t('The address line in <strong>@fieldset</strong> looks incomplete. Please enter street & number.', { '@fieldset': firstWarningFieldset })
					}));

					// Remove the loading overlay that is triggered in some scenarios
					$('.ajax-progress-fullscreen', context).remove();
					$('body').removeClass('js-page-loading');
				}

				return allowSubmit;
			});
		}
	};

  Drupal.behaviors.postalCodes = {
      attach: function (context, settings) {
        //   Seperate shipping address on checkout
        var $checkoutShippingAddressPostalCode = $('input[name="duo_commerce_delivery__delivery[delivery-method-form][hairco_commerce__standard][address-wrapper][address][postal_code]"]', context);
        $checkoutShippingAddressPostalCode.on('input', function(e) {
            if (this.value.length == 4) {
                this.blur();
            }
        });
        // Profile edit screen
        var $profileBillingAddressPostalCode = $('.path-user input[name="billing_profile[address][0][address][postal_code]"]', context);
        $profileBillingAddressPostalCode.on('input', function(e) {
            if (this.value.length == 4) {
                this.blur();
            }
        });

        var $profileShippingAddressPostalCode = $('.path-user input[name="field_delivery_address[0][address][postal_code]"]', context);
        $profileShippingAddressPostalCode.on('input', function(e) {
            if (this.value.length == 4) {
                this.blur();
            }
        });
      }
  };

  Drupal.behaviors.yourVouchersBlock = {
    attach: function (context, settings) {
      var $mvb = $('.my-vouchers-block', context);
      var labelShow = '<span class="sr-label">' + Drupal.t('Show my vouchers') + '</span>' +
                      '<span class="button-symbol"></span>';
      var labelHide = '<span class="sr-label">' + Drupal.t('Hide my vouchers') + '</span>'+
                      '<span class="button-symbol">&mdash;</span>';

      if ($mvb.length) {
        if (sessionStorage['vouchers.hairco.com'] === undefined) {
          // By default we show the personal vouchers block
          sessionStorage['vouchers.hairco.com'] = 'collapsed';
        }

        var $mvb_toggle = $('<button></button>', {
          class: 'js-mvb-toggle',
          type: 'button',
          html: labelShow,
        }).on('click', function(e) {
          if ($mvb.hasClass('voucher-details-shown')) {
            $mvb.removeClass('voucher-details-shown');
            $(this).html(labelShow);
            sessionStorage['vouchers.hairco.com'] = 'collapsed';
          } else {
            $mvb.addClass('voucher-details-shown');
            $(this).html(labelHide);
            sessionStorage['vouchers.hairco.com'] = 'expanded';
          }
        });

        $mvb.find('.my-vouchers-block-info-text').append($mvb_toggle);

        if (sessionStorage['vouchers.hairco.com'] === 'expanded') {
          $mvb.addClass('voucher-details-shown');
          $mvb_toggle.html(labelHide);
        }
      }
    }
  };



/** --------------------------------------------------
    #overrule behavior
    -------------------------------------------------- */

	/* This is a copy of the "commerce_cart.js" drupal behavior
	 * -> we don't want the original js to run, so we overwrite
	 *    it here;
	 */

	Drupal.behaviors.commerceCartBlock = {
		attach: function (context) {
			// do nothing...
		}
	};




})(jQuery, window.duo = window.duo || {});
